import React from "react";
import * as Mui from "@mui/material";
import { withStyles } from "tss-react/mui";
import type { WithStyles } from "type/tss";
import { useSelector } from "react-redux";
import { getUserUnsafe } from "redux/selector";
import { styles } from "./style";
import { Helmet } from "react-helmet";
import { urls } from "routes/urls";
import * as paths from "routes/paths";
import { RouterLinkWrapper } from "component/shared/router-link-wrapper";
import { ArrowBack } from "@mui/icons-material";
import { ErrorPageContext } from "./context";

interface Props extends WithStyles<typeof styles> {
	title: string;
	header: React.ReactNode;
	message: React.ReactNode;
	subtitle?: React.ReactNode;
}

const Component: React.FC<Props> = ({ classes = {}, title, header, message, subtitle }) => {
	const user = useSelector(getUserUnsafe);
	const setErrorPage = React.useContext(ErrorPageContext);

	React.useEffect(() => {
		setErrorPage(true);
		return () => setErrorPage(false);
	}, [setErrorPage]);

	return (
		<>
			<Helmet
				title={title}
			/>
			<div className={classes.layout}>
				<div className={classes.container}>
					<h1 className={classes.header}>{header}</h1>
					<p className={classes.title}>{message}</p>
					{subtitle && <p className={classes.message}>{subtitle}</p>}
					<div className={classes.actions}>
						<RouterLinkWrapper to={user ? urls.landing(user) : paths.login}>
							<Mui.Button variant="contained" color="primary" startIcon={<ArrowBack />}>
								Back to Home
							</Mui.Button>
						</RouterLinkWrapper>
						<RouterLinkWrapper to={paths.supportCenter}>
							<Mui.Button variant="outlined" color="primary">
								Contact Support
							</Mui.Button>
						</RouterLinkWrapper>
					</div>
				</div>
			</div>
		</>
	);
};

export const ErrorLayout = withStyles(Component, styles);
